<!-- <div class="auth-page-wrapper pt-5">
  <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
      <div class="bg-overlay"></div>

      <div class="shape">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
              <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
          </svg>
      </div>
  </div>

  <div class="auth-page-content">
      <div class="container">
          <div class="row">
              <div class="col-lg-12">
                  <div class="text-center mt-sm-5 pt-4">
                      <div class="mb-5 text-white-50">
                          <h1 class="display-5 coming-soon-text">Site is Under Maintenance</h1>
                          <p class="fs-14">Please check back in sometime</p>
                          <div class="mt-4 pt-2">
                              <a routerLink="/" class="btn btn-success"><i class="mdi mdi-home me-1"></i> Back to Home</a>
                          </div>
                      </div>
                      <div class="row justify-content-center mb-5">
                          <div class="col-xl-4 col-lg-8">
                              <div>
                                  <img src="assets/images/maintenance.png" alt="" class="img-fluid">
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

      </div>
  </div>
  <footer class="footer">
      <div class="container">
          <div class="row">
              <div class="col-lg-12">
                  <div class="text-center">
                      <p class="mb-0 text-muted">&copy; {{year}} Velzon. Crafted with <i class="mdi mdi-heart text-danger"></i> by Themesbrand</p>
                  </div>
              </div>
          </div>
      </div>
  </footer>

</div> -->


<div class="auth-page-wrapper pt-5">
  <!-- auth page bg -->
  <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
    <div class="bg-overlay"></div>

    <div class="shape">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1440 120">
        <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
      </svg>
    </div>
  </div>

  <!-- auth page content -->
  <div class="auth-page-content">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mt-sm-5 pt-4">
            <div class="mb-5 text-white-50">
              <h1 class="display-5 coming-soon-text">Something went wrong</h1>
              <p class="fs-14">Kindly contact admin for further details.</p>
              <p class="fs-14 text-warning">Redirecting in {{ countdown }} seconds...</p>
              <!-- <div class="mt-4 pt-2">
                <a href="https://dev-ubi-store.kellton.net/product?attribute=&priceFrom=&priceTo=&brand=&offset=0&index=0&categorySlug=&categoryId=&sortby=&order=&popular=&deal=&flashDeal=&subCategorySlug=&keyword=&name=&discountDeal=" class="btn btn-success">
                  <i class="mdi mdi-home me-1"></i> Go to Store
                </a>
              </div> -->
            </div>
            <!-- <div class="row justify-content-center mb-5">
              <div class="col-xl-4 col-lg-8">
                <div>
                  <img src="assets/images/maintenance.png" alt="Maintenance" class="img-fluid">
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </div>
  <!-- end auth page content -->

  <!-- footer -->
  <footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-3">
               &nbsp;
               &nbsp;
            </div>
            <div class="col-sm-6">
               Powered by <img src="assets/images/zillion.png" alt="" height="50">
               &nbsp;
            </div>
            <div class="col-sm-3">
                <div class="text-sm-end d-none d-sm-block">
                    &nbsp;
                    &nbsp;
                </div>
            </div>
        </div>
    </div>
</footer>
  <!-- end Footer -->
</div>

<!-- Auto Redirect Script -->
<script>
  let countdown = 5;
  const timerElement = document.getElementById('timer');
  const redirectUrl = "https://dev-ubi-store.kellton.net/product?attribute=&priceFrom=&priceTo=&brand=&offset=0&index=0&categorySlug=&categoryId=&sortby=&order=&popular=&deal=&flashDeal=&subCategorySlug=&keyword=&name=&discountDeal=";

  const interval = setInterval(() => {
    countdown--;
    timerElement.textContent = countdown;
    if (countdown === 0) {
      clearInterval(interval);
      window.location.href = redirectUrl;
    }
  }, 1000);
</script>
